import { Box, Icon } from "@mui/material";
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import moment from "moment";

const MAX_OFFLINE = 48;
const DEVICE_TIMEOUT = 0.5;
const BATTERY_THRESHOLD = 25;

export function calculateBattery(voltage, is_12v = null, voltage_multiplier = null) {
    // dbg(voltage, true);
    if (voltage_multiplier != null) {
        voltage = voltage * voltage_multiplier;
    }
    else if (is_12v) {
        voltage = voltage / 0.849;
    }

    var levels = [
        2850, 2830, 2815, 2800, 2790, 2780, 2770, 2760, 2750, 2745, 2740, 2738, 2736, 2734, 2732, 2730, 2728, 2726, 2724, 2722, 2721, 2719, 2717, 2716, 2715, 2714, 2712, 2710, 2709, 2708, 2707, 2705, 2704, 2703, 2702, 2701, 2699, 2698, 2697, 2696, 2695, 2694, 2693, 2692, 2691, 2689, 2688, 2687, 2686, 2685, 2683, 2682, 2681, 2680, 2679, 2677, 2676, 2675, 2674, 2673, 2671, 2670, 2669, 2668, 2667, 2665, 2664, 2663, 2662, 2660, 2658, 2657, 2656, 2654, 2652, 2650, 2649, 2647, 2645, 2643, 2641, 2639, 2636, 2631, 2626, 2620, 2613, 2606, 2598, 2590, 2580, 2565, 2550, 2535, 2520, 2505, 2490, 2470, 2450, 2430, 2410
    ];

    var value = 0;
    for (var key in levels) {
        if (voltage >= levels[key]) {
            return (100 - key);
        }
    }
    return 0;
}

export function celciusToFahrenheit(celcius) {
    return Number(celcius) * 9 / 5 + 32;
}

export function convertBattery(voltage, is_32, multiplier) {
    if (typeof multiplier != "undefined" && multiplier != null) {
        voltage = voltage * multiplier;
    }
    else if (typeof is_32 != "undefined" && is_32) {
        voltage = voltage / 0.849;
    }

    var levels = [
        2755.5, 2739, 2730.75, 2722.5, 2712.5, 2706, 2697.75, 2689.5, 2685.375, 2681.25, 2677.125, 2673, 2664.75, 2656.5, 2648.25, 2640, 2615.25, 2582.25, 2433.75, 2062.5
    ];

    for (var x in levels) {
        if (voltage >= levels[x]) {
            return (20 - x) * 5;
        }
    }

    return voltage == 0 ? 100 : 0;
}

export function processUptimeCounts(data) {

    var processed_devices = data.map(function (row) {
        var ret = {};
        ret.name = "";
        ret.uuid = row.uuid;
        ret.skin = row.skin;
        ret.connected_state = row.connected_state;
        ret.active = row.active;

        return ret;
    }).filter(row => row.active);

    var count = processed_devices.length;

    var uptime_status = {
        is_online: 0,
        is_offline: 0
    };

    for (var device of processed_devices) {

        if (device.connected_state == 'offline') {
            uptime_status.is_offline++;
        }
        else {
            uptime_status.is_online++;
        }
    }

    return { count: count, uptime_status: Object.values(uptime_status) };
}

function createDevicePointSeverities(rows) {
    for (var row of rows) {
        var severity_state = 0;

        if (!row.active) {
            severity_state += 100;
        }

        if (row.connected_state == "offline") {
            severity_state -= 1;
        }
        else {
            severity_state += 0;
        }

        if (row.battery > 60) {
            severity_state += 2;
        }
        else if (row.battery >= 35) {
            severity_state += 1;
        }
        else if (row.battery <= BATTERY_THRESHOLD) {
            severity_state -= 1;
        }

        // if (row.rssi <= 70) {
        //     severity_state += 2;
        // }
        // else if (row.rssi <= 85) {
        //     severity_state += 1;
        // }

        // if (row.humidity <= 55) {
        //     severity_state += 2;
        // }
        // else if (row.humidity > 55 && row.humidity <= 80) {
        //     severity_state += 1;
        // }

        // if (row.temperature > 60 || row.temperature < -5) {
        //     severity_state += 0;
        // }
        // else if (row.temperature > 45 || row.temperature < 5) {
        //     severity_state += 1;
        // }
        // else if (row.temperature <= 45 || row.temperature >= 5) {
        //     severity_state += 2;
        // }

        row.severity_state = severity_state;
    }

    return rows;
}

function sortByDeviceData(a, b) {
    if (a.active && !b.active) {
        return -1;
    }
    else if (!a.active && b.active) {
        return 1;
    }
    else {
        if (a.connected_state == "offline" && b.connected_state != "offline") {
            return -1;
        }
        else if (a.connected_state != "offline" && b.connected_state == "offline") {
            return 1;
        }
        else {
            if (a.severity_state < 0 || b.severity_state < 0) {
                return a.severity_state - b.severity_state;
            }
            else {
                if (a.device_id != null && b.device_id != null) {
                    return a.device_id - b.device_id;
                }
                if (a.site_id != null && b.site_id != null) {
                    return a.site_id - b.site_id;
                }
            }
        }

        return a.severity_state - b.severity_state;
    }
}

export function processDevicesData(devices, show_inactive = false, group_type = false) {

    var processed = devices.map(function (device) {
        return processDeviceData(device, group_type);
    });

    // console.log(processed)

    if (!show_inactive) {
        processed = processed.filter(device => { return device.active });
    }

    return createDevicePointSeverities(processed).sort(sortByDeviceData);
}

export function processDeviceData(device, group = false) {
    var ret = {};
    const static_vals = {
        current_time: moment().unix(),
        voltage_multiplier: 0.4125,
    };

    ret.name = device.name ? device.name : device.device_name;
    ret.serial_number = device.serial_number;
    ret.module_type = device.module_type;
    ret.organisation_id = device.organisation_id;
    ret.db_type = device.db_type;
    ret.uuid = device.uuid;
    ret.stop = {
        site_id: device.site_id
    };
    ret.site_id = device.site_id;
    ret.device_id = device.device_id ? device.device_id : null;
    ret.hardware_type = device?.type ? device.type : device.hardware_type;

    ret.position = [device.position.longitude, device.position.latitude];

    ret.overlay_id = device?.overlay_id;
    ret.liveview_type = "on";

    ret.connected_state = "offline";
    ret.last_updated = "Never";
    ret.last_heartbeat = 0;
    ret.active = device.active;
    ret.multiplier = typeof device.multiplier != "undefined" ? device.multiplier : 1;

    ret.battery = "";
    ret.temperature = "";
    ret.rssi = "";
    ret.humidity = "";
    ret.firmware_version = "";

    if (typeof device.bks != "undefined" && device.bks != null) {
        ret = processBKSData(ret, device, static_vals, group);
    }
    else if (typeof device.visionect != "undefined" && device.visionect != null) {
        ret = processVisionectData(ret, device, static_vals);
    }

    // console.log(ret, device)

    return ret;
}

function processVisionectData(ret, device, static_vals) {
    var { current_time, voltage_multiplier } = static_vals;

    switch (device.device_type_id) {
        case "1":
        case "2":
        case "7":
        case "8":
            ret.device_type = "single";
            if (device.visionect.screens[0]["Displays"][0]["Rotation"] % 2 == 0) {
                ret.device_type = "single_landscape";
            }
            break;
        case "4":
            ret.device_type = "32";
            if (device.visionect.screens[0]["Displays"][0]["Rotation"] % 2 == 0) {
                ret.device_type = "32_landscape";
            }
            break;
        case "5":
            ret.device_type = "double";
            if (device.visionect.screens[0]["Displays"][0]["Rotation"] % 2 == 0) {
                ret.device_type = "double_landscape";
            }
            break;
        case "11":
            ret.device_type = "42";
            if (device.visionect.screens[0]["Displays"][0]["Rotation"] % 2 == 0) {
                ret.device_type = "42_landscape";
            }
            break;
    }

    ret.stop = {
        stop_id: device.stop.stop_id,
        stop_label: device.stop.stop_label
    };

    ret.tts = {
        enabled: device.tts_volume != null ? 1 : 0,
        volume: device.tts_volume
    };

    var data = device.visionect.screens.map((screen) => {
        var connected_state = "offline";
        var connected_val = 1;
        var last_heartbeat = screen['CMS']['last_updated'];

        if (current_time <= last_heartbeat + 10 * 60) {
            connected_state = "online";
            connected_val = 3;
        }
        else if (current_time > last_heartbeat + 10 * 60 && current_time <= last_heartbeat + 20 * 60) {
            connected_state = "reconnecting";
            connected_val = 2;
        }

        var battery = convertBattery(Number(screen?.['Status']?.['ExternalBattery']), device.visionect.is_32, device.voltage_multiplier) || 0;
        var temperature = screen?.['Status']?.['Temperature'] || 0;
        var humidity = screen?.['Status']?.['HumiditySensor'] || 0;
        var rssi = screen?.['Status']?.['RSSI'] || 0;

        return {
            last_heartbeat,
            connected_state,
            connected_val,
            battery,
            temperature,
            humidity,
            rssi
        }
    });

    ret.is_32 = device.visionect.is_32;
    ret.uuids = device.visionect.uuids;

    ret.last_heartbeat = data.sort((a, b) => { return Number(a.last_heartbeat) - Number(b.last_heartbeat) })[0].last_heartbeat; // oldest time
    ret.last_updated = moment(ret.last_heartbeat * 1000).format("hh:mm A, DD/MM/YY");

    ret.connected_state = data.sort((a, b) => { return Number(a.connected_val) - Number(b.connected_val) })[0].connected_state; // worst connected state

    ret.battery = data.sort((a, b) => { return Number(a.battery) - Number(b.battery) })[0].battery; // lowest battery
    ret.temperature = data.sort((a, b) => { return Number(b.temperature) - Number(a.temperature) })[0].temperature; // worst temp
    ret.humidity = data.sort((a, b) => { return Number(b.humidity) - Number(a.humidity) })[0].humidity; // worst humidity
    ret.rssi = data.sort((a, b) => { return Number(b.rssi) - Number(a.rssi) })[0].rssi; // largest rssi

    return ret;
}

function processBKSData(ret, device, static_vals, group) {
    var { current_time, voltage_multiplier } = static_vals;

    ret.last_heartbeat = device.bks.last_heartbeat;
    ret.last_updated = moment(device.bks.last_heartbeat * 1000).format("hh:mm A, DD/MM/YY");

    switch (device.organisation_id) {
        case "clearways":
            ret.device_type = "single_landscape";
            ret.overlay_id = "clearways";
            ret.liveview_type = "history";

            if (device.voltage_multiplier == 12.2) {
                voltage_multiplier = 0.825;
            }

            if (typeof device.bks.expected_online_at != "undefined" && current_time <= device.bks.expected_online_at + (DEVICE_TIMEOUT * 60 * 60)) {
                ret.connected_state = "online";
            }
            else if (current_time <= device.bks.last_heartbeat + ((MAX_OFFLINE + DEVICE_TIMEOUT) * 60 * 60)) {
                ret.connected_state = "online";
            }
            break;
        default:
            ret.device_type = device.device_type;
            if (typeof ret.stop.site_id == 'undefined') {
                ret.stop = device?.stop ? { ...device.stop } : null;
            }
            ret.tts = device.bks.tts;
            ret.liveview_type = device.bks.live_view;

            if (typeof device.bks.expected_online_at != "undefined" && current_time < device.bks.expected_online_at) {
                ret.connected_state = "sleeping";
            }
            else if (current_time <= device.bks.last_heartbeat + 10 * 60) {
                ret.connected_state = "online";
            }
            else if (current_time > device.bks.last_heartbeat + 10 * 60 && current_time <= device.bks.last_heartbeat + 20 * 60) {
                ret.connected_state = "reconnecting";
            }
            break;
    }

    if (typeof device.bks.latest_logs != "undefined") {
        if (typeof device.bks.latest_logs.status != "undefined") {
            ret.battery = calculateBattery(device.bks.latest_logs.status.battery_reading, null, voltage_multiplier) || 0;
            ret.temperature = device.bks.latest_logs.status.internal_temp || 0;
            ret.humidity = device.bks.latest_logs.status.internal_humidity || 0;
        }

        if (typeof device.bks.latest_logs.GSMStatus != "undefined") {
            ret.rssi = device.bks.latest_logs.GSMStatus.rssi || 0;
            ret.gsm = {
                network: device.bks.latest_logs.GSMStatus.network,
                operator: device.bks.latest_logs.GSMStatus.operator,
                frequency: device.bks.latest_logs.GSMStatus.frequency
            }
        }

        if (typeof device.bks.latest_logs.boot != "undefined") {
            ret.firmware_version = device.bks.latest_logs.boot.firmware_version || 0;
        }
    }

    return ret;
}

export function setDeviceColour(device, showAdvancedDeviceLevel) {
    switch (device.organisation_id) {
        case "clearways":
            if (!device.active && showAdvancedDeviceLevel) {
                return "#555555";
            }
            else {
                if (device.connected_state != "online") {
                    return "#ff667c";
                }
                else if (device.battery <= BATTERY_THRESHOLD && showAdvancedDeviceLevel) {
                    return "#edaa00";
                }
                else {
                    return "#58ba2d";
                }
            }
        default:
            if (!device.active && showAdvancedDeviceLevel) {
                return "#000";
            }

            switch (device.connected_state) {
                case "sleeping":
                    return "#555555";
                case "offline":
                    return "#ff667c";
                case "reconnecting":
                    return "#edaa00";
                case "online":
                    return "#58ba2d";
                default:
                    return "#000";
            }
    }
}

function setDeviceDisplayType(device) {
    switch (device.device_type) {
        case "double":
            return `Dual 13.3" eModule, 1600x3200px`;
        case "double_landscape":
            return `Dual 13.3" eModule, 3200x1600px`;
        case "32":
            return `32" eModule, 1440x2160px`;
        case "32_landscape":
            return `32" eModule, 2160x1440px`;
        case "42":
            return `42" eModule, 2160x2880px`;
        case "42_landscape":
            return `42" eModule, 2880x2160px`;
        case "single":
            return `13.3" eModule, 1200x1600px`;
        case "single_landscape":
        case "single_landscape_inverted":
        case "single_landscape_colour":
            return `13.3" eModule, 1600x1200px`;
        case "11":
            return `11" eModule`;
        case "parking_13":
            return `13.3" eModule, 1600x1200px`;
        default:
            return `13.3" eModule, 1200x1600px`;
    }
}

export function getConnectivityIcon(device, showAdvancedDeviceLevel) {
    if (!device.active && showAdvancedDeviceLevel) {
        var text = `Inactive (System ${device.connected_state})`;
        return { text, component: 'visibility_off', colour: 'secondary' };
    }

    var text = `System ${device.connected_state}`;

    switch (device.connected_state) {
        case 'sleeping':
            if (showAdvancedDeviceLevel) {
                return { text, component: 'bedtime', colour: 'secondary' };
            }
            return { text: `System Online`, component: 'wifi', colour: 'success' };
        case 'offline':
            return { text, component: 'wifi_off', colour: 'error' };
        case 'reconnecting':
            return { text, component: 'wifi_protected_setup', colour: 'warning' };
        case 'online':
            return { text, component: 'wifi', colour: 'success' };
        default:
            return { text, component: 'question_mark', colour: 'dark' };
    }
}

export function getDeviceTypeIcon(device, showAdvancedDeviceLevel) {
    if (!device.active && showAdvancedDeviceLevel) {
        var text = device.hardware_type == "bk-camera" ? `Camera Inactive` : `LiveView Inactive`
        return { text, component: 'visibility_off', colour: 'secondary' };
    }

    var text = device.hardware_type == "bk-camera" ? `Camera Active` : `LiveView Active`;
    switch (device.hardware_type) {
        case 'nuc':
        case 'visionect':
        case 'bk':
            return { text, component: 'photo', colour: 'dark' };
        case 'bk-camera':
            return { text, component: 'camera_alt', colour: 'dark' };
        default:
            return { text, component: 'question_mark', colour: 'dark' };
    }
}

export function getHealthStatus(device, showAdvancedDeviceLevel) {

    // EXCELLENT ?????
    // GOOD
    // FAIR
    // POOR

    var statistics = device;
    var health = { text: "POOR", color: "error" };

    if(!device.active){
        health = { text: "INACTIVE", color: "secondary" };
    }
    else if (device.connected_state != 'offline') {
        if (statistics.battery <= BATTERY_THRESHOLD) {
            health = { text: "POOR", color: "error" };
        }
        else if (statistics.battery > BATTERY_THRESHOLD && statistics.battery <= 60) {
            if (statistics.temperature > 60 || statistics.temperature < -5) {
                health = { text: "POOR", color: "error" };
            }
            else if (statistics.temperature > 45 || statistics.temperature < 5) {
                health = { text: "FAIR", color: "warning" };
            }
            else if (statistics.temperature <= 45 || statistics.temperature >= 5) {
                health = { text: "GOOD", color: "success" };
            }
        }
        else {
            if (statistics.temperature > 60 || statistics.temperature < -5) {
                health = { text: "FAIR", color: "warning" };
            }
            else if (statistics.temperature > 45 || statistics.temperature < 5) {
                health = { text: "GOOD", color: "success" };
            }
            else if (statistics.temperature <= 45 || statistics.temperature >= 5) {
                health = { text: "GOOD", color: "success" };//{ text: "EXCELLENT", color: "success" };
            }
        }

        if (health.text == "POOR" && !showAdvancedDeviceLevel) {
            health = { text: "FAIR", color: "warning" };
        }
    }

    return health;
}

export {
    setDeviceDisplayType
}

export function createDataTableRows(devices, showAdvancedDeviceLevel) {

    var data_table_data = {
        columns: [], rows: devices.map((row) => {
            row.accessor_id = row.stop != null ? (row.stop?.stop_id ? row.stop.stop_id : row.stop.site_id) : "N/A";
            return row;
        })
    };

    function visionectValueSort(rowa_vis, rowa_bk, rowb_vis, rowb_bk) {
        var rowa_val = rowa_vis ? rowa_vis.sort()[0] : rowa_bk;
        var rowb_val = rowb_vis ? rowb_vis.sort()[0] : rowb_bk;

        if (rowa_val > rowb_val) {
            return 1;
        }
        else if (rowa_val < rowb_val) {
            return -1;
        }
        else {
            return 0;
        }
    }

    if (showAdvancedDeviceLevel) {
        data_table_data.columns = [
            {
                Header: 'Name',
                accessor: 'name',
                Cell: ({ cell }) => {
                    if (cell.row.original.connected_state != 'eco') {
                        return cell.row.original.name;
                    }
                    else {
                        return (
                            <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
                                {cell.row.original.name}
                                <SoftBox variant="gradient" sx={{ background: 'transparent' }}>
                                    <Icon color="success" sx={{
                                        background: ({ functions: { linearGradient }, palette: { gradients } }) =>
                                            linearGradient(gradients["success"].main, gradients["success"].state),
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                        display: 'block'
                                    }}>compost</Icon>
                                </SoftBox>
                            </Box>
                        );
                    }
                }
            },
            {
                Header: 'Site/Stop ID',
                accessor: 'accessor_id',
                Cell: ({ cell }) => {
                    var ret = cell.row.original.accessor_id;

                    if (cell.row.original.accessor_id.length > 15) {
                        ret = cell.row.original.accessor_id.substr(0, 15) + '...';
                    }
                    return ret;
                }
            },
            {
                Header: 'Battery',
                accessor: 'battery',
                Cell: ({ cell }) => {
                    return cell.row.original?.visionect?.batteries ? cell.row.original.visionect.batteries[0] : cell.row.original.battery;
                },
                sortType: function (rowa, rowb) {
                    return visionectValueSort(rowa.original?.visionect?.batteries, rowa.original.battery, rowb.original?.visionect?.batteries, rowb.original.battery);
                }
            },
            {
                Header: 'Temperature',
                accessor: 'temperature',
                Cell: ({ cell }) => {
                    return cell.row.original?.visionect?.temperatures ? cell.row.original.visionect.temperatures[0] : cell.row.original.temperature;
                },
                sortType: function (rowa, rowb) {
                    return visionectValueSort(rowa.original?.visionect?.temperatures, rowa.original.temperature, rowb.original?.visionect?.temperatures, rowb.original.temperature);
                }
            },
            {
                Header: 'Humidity',
                accessor: 'humidity',
                Cell: ({ cell }) => {
                    return cell.row.original?.visionect?.humidities ? cell.row.original.visionect.humidities[0] : cell.row.original.humidity;
                },
                sortType: function (rowa, rowb) {
                    return visionectValueSort(rowa.original?.visionect?.humidities, rowa.original.humidity, rowb.original?.visionect?.humidities, rowb.original.humidity);
                }
            },
            {
                Header: 'RSSI',
                accessor: 'rssi',
                Cell: ({ cell }) => {
                    return cell.row.original?.visionect?.rssis ? cell.row.original.visionect.rssis[0] : cell.row.original.rssi;
                },
                sortType: function (rowa, rowb) {
                    return visionectValueSort(rowa.original?.visionect?.rssis, rowa.original.rssi, rowb.original?.visionect?.rssis, rowb.original.rssi);
                }
            },
            {
                Header: 'Serial Number',
                accessor: 'serial_number'
            },
            {
                Header: 'Last Updated',
                accessor: 'last_updated',
                sortType: function (rowa, rowb) {
                    return visionectValueSort(undefined, rowa.original.last_heartbeat, undefined, rowb.original.last_heartbeat);
                }
            }
        ];
    }
    else {
        data_table_data.columns = [
            {
                Header: 'Name',
                accessor: 'name',
                Cell: ({ cell }) => {
                    if (cell.row.original.connected_state != 'eco') {
                        return cell.row.original.name;
                    }
                    else {
                        return (
                            <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
                                {cell.row.original.name}
                                <SoftBox variant="gradient" sx={{ background: 'transparent' }}>
                                    <Icon color="success" sx={{
                                        background: ({ functions: { linearGradient }, palette: { gradients } }) =>
                                            linearGradient(gradients["success"].main, gradients["success"].state),
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                        display: 'block'
                                    }}>compost</Icon>
                                </SoftBox>
                            </Box>
                        );
                    }
                }
            },
            {
                Header: 'Site/Stop ID',
                accessor: 'accessor_id',
                Cell: ({ cell }) => {
                    var ret = cell.row.original.accessor_id;

                    if (cell.row.original.accessor_id.length > 15) {
                        ret = cell.row.original.accessor_id.substr(0, 15) + '...';
                    }
                    return ret;
                }
            },
            {
                Header: 'Battery',
                accessor: 'battery',
                Cell: ({ cell }) => {
                    return cell.row.original?.visionect?.batteries ? cell.row.original.visionect.batteries[0] : cell.row.original.battery;
                },
                sortType: function (rowa, rowb) {
                    return visionectValueSort(rowa.original?.visionect?.batteries, rowa.original.battery, rowb.original?.visionect?.batteries, rowb.original.battery);
                }
            },
            {
                Header: 'Temperature',
                accessor: 'temperature',
                Cell: ({ cell }) => {
                    return cell.row.original?.visionect?.temperatures ? cell.row.original.visionect.temperatures[0] : cell.row.original.temperature;
                },
                sortType: function (rowa, rowb) {
                    return visionectValueSort(rowa.original?.visionect?.temperatures, rowa.original.temperature, rowb.original?.visionect?.temperatures, rowb.original.temperature);
                }
            },
            {
                Header: 'Serial Number',
                accessor: 'serial_number'
            },
            {
                Header: 'Health Status',
                accessor: 'health_status',
                Cell: ({ cell }) => {
                    var health_status = getHealthStatus(cell.row.original);
                    return (
                        <SoftTypography color={health_status.color} textGradient sx={{ fontSize: '14px', fontWeight: 'bold', verticalAlign: "middle" }}>
                            {health_status.text}
                        </SoftTypography>
                    )
                }
            }
        ];
    }

    return data_table_data;
}